import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ParticipationRateMaintenanceCont from "presentation/view/container/ParticipationRate/ParticipationRateContMain";

CommonEntrypoint(<ParticipationRateMaintenanceCont/>)